import { render } from "./UnitButton.vue?vue&type=template&id=3d690fb4&scoped=true&ts=true"
import script from "./UnitButton.vue?vue&type=script&lang=ts"
export * from "./UnitButton.vue?vue&type=script&lang=ts"

import "./UnitButton.vue?vue&type=style&index=0&id=3d690fb4&lang=scss&scoped=true"

import exportComponent from "/home/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d690fb4"]])

export default __exports__